module.exports = __webpack_public_path__ + "img/mi-new-releases.b28d4639.svg";